import { CliError } from "@/lib/cli/cli-error";
import { LIMITS } from "@/commands/answers/collect-answers-constants";
import type { Answer } from "@/commands/answer/answer";
import { validateFreeText } from "@/commands/answer/validate-free-text";
import { validateSelectedOptionIds } from "@/commands/answer/validate-selected-option-ids";
/** `label` names the source — `--answers[2]` or `--option q1=…` — because both
 *  entry paths build the same shape and must fail identically. */
export function validateAnswer(answer: Answer, label: string): void {
  // The ONE field the server does not trim, so its ceiling applies to the raw
  // value. Emptiness is checked more strictly than the API on purpose: a blank
  // id passes `min(1)` and then matches no question, leaving the round silently
  // unanswered.
  if (answer.questionId.trim().length === 0) {
    throw new CliError(`${label} needs a non-empty "questionId".`, 2);
  }
  if (answer.questionId.length > LIMITS.QUESTION_ID) {
    throw new CliError(
      `${label} has a "questionId" longer than ${LIMITS.QUESTION_ID} characters.`,
      2,
    );
  }

  const options = answer.selectedOptionIds;
  validateSelectedOptionIds(options, label);
  validateFreeText(answer.freeText, label);

  // The server's own rule; `--option q1=,,` reaches exactly this shape.
  if (
    (options === undefined || options.length === 0) &&
    answer.freeText === undefined
  ) {
    throw new CliError(
      `${label} answers nothing. Give it at least one option id or some free text.`,
      2,
    );
  }
}
